
import { Pedido } from '@/types/types'
import Axios, { AxiosPromise } from 'axios'

export class PedidoService {
  fectchAllRequest (start: string, end: string): AxiosPromise<{data: Pedido[]}> {
    return Axios.get(`/pedidos?start=${start}&end=${end}`)
  }

  fectchDetailRequest (id: string): AxiosPromise {
    return Axios.get(`/pedidos/detail/${id}`)
  }

  fetchOneRequest (id: string) {
    return Axios.get(`/pedidos/${id}`)
  }
}
